define('drops/boolImageInput/boolImageInput',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq',
    'lq/util',
    'lq/constants',
    'lq/required'
], function ($, Drop, Style, lq, util, constants, Required) {
    'use strict';

    var defaults = {
        data: {
            size: { x: 50, y: 50 },
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            },
            isTriStateEnabled: false
        }
    };

    function BoolImageInput(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        var self = this;

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);
        this.value = false;

        this.$img = $('<img />')
            .attr('title', this.data.title)
            .attr('tabindex', this.data.tabIndex)
            .attr('draggable', 'false')
            .css({
                position: 'absolute',
                width: '100%',
                height: '100%'
            })
			.on('dragstart', function (e) { e.preventDefault(); })
            .appendTo(this.$element);

        this.changeValueTo(this.data.defaultValue || false);

        if (!this.data.readOnly && !this.designData) {
            this.$img
				.css({ cursor: 'pointer' })
                .on('click', function () {
                    self.handleClick();

                    var isChecked = self.value;
                    self.triggerEventIfEnabled('toggled', isChecked);
                    if (isChecked === true) {
                        self.triggerEventIfEnabled('checked');
                    } else if (isChecked === false) {
                        self.triggerEventIfEnabled('unchecked');
                    } else {
                        self.triggerEventIfEnabled('nullchecked');
                    }
                });
        }

        this.$element
            .addClass('boxToBorderSize')
            .css({
                whiteSpace: 'pre-wrap',
                overflow: 'hidden'
            });

        Style.renderStyles(this);

        if (this.data.readOnly)
            this.$img.prop('readonly', true);
    }

    Drop.extend(BoolImageInput, Drop);

    BoolImageInput.typeName = 'BoolImageInput';

    BoolImageInput.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        Required.prototype.addRemoveRequiredIndicator(this);
        this.applyPosition();
    };

    BoolImageInput.prototype.getValue = function () {
        return this.value;
    };

    BoolImageInput.prototype.handleClick = function () {
        if (!this.data.isTriStateEnabled)
            this.changeValueTo(!this.value);
        else {
            if (this.value) {
                this.changeValueTo(!this.value);
            } else if (this.value === false) {
                this.changeValueTo(null);
            } else {
                this.changeValueTo(true);
            }
        }
        this.updateRequiredIndicator();
    };

    BoolImageInput.prototype.clearValue = function () {
        this.changeValueTo(false);
        this.updateRequiredIndicator();
    };

    BoolImageInput.prototype.setValue = function (update) {
        var isTrue = this.isTrue(update);
        this.changeValueTo(isTrue);
        this.updateRequiredIndicator();
    };

    BoolImageInput.prototype.getNullImageUrl = function () {
        if (!this.data.nullImage)
            return lq.getCdnUrl('Drops/BoolImageInput/Defaults/null.png');
        return lq.getTenantUploads(this.data.nullImage);
    };

    BoolImageInput.prototype.getFalseImageUrl = function () {
        if (!this.data.falseImage)
            return lq.getCdnUrl('Drops/BoolImageInput/Defaults/false.png');
        return lq.getTenantUploads(this.data.falseImage);
    };

    BoolImageInput.prototype.getTrueImageUrl = function () {
        if (!this.data.trueImage)
            return lq.getCdnUrl('Drops/BoolImageInput/Defaults/true.png');
        return lq.getTenantUploads(this.data.trueImage);
    };

    BoolImageInput.prototype.changeValueTo = function (value) {
        var imageUrl;
        if (value === true) {
            imageUrl = this.getTrueImageUrl();
        } else if (value === false) {
            imageUrl = this.getFalseImageUrl();
        } else {
            imageUrl = this.getNullImageUrl();
        }

        // in some cases Firefox does not replace the image on the first click
        // but using setTimeout seems to solve it
        var $img = this.$img;
        setTimeout(function () {
            $img.attr('src', imageUrl);
        }, 0);

        this.value = value;
    };

    BoolImageInput.prototype.isTrue = function (update) {
        if (!this.data.isTriStateEnabled) {
            return update.value === true ||
            (update.type === constants.valueTypes.string
                && update.value
                && update.value.toString().toLowerCase() === 'true');
        } else if (update.value === true ||
            (update.type === constants.valueTypes.string
                && update.value
                && update.value.toString().toLowerCase() === 'true')) {
            return true;
        } else if (update.value === false ||
            (update.type === constants.valueTypes.string
                && update.value
                && update.value.toString().toLowerCase() === 'false')) {
            return false;
        }
        return null;
    };

    return BoolImageInput;
});
